import React from 'react';

import MuiTableCell from '@material-ui/core/TableCell';
import MuiTableRow from '@material-ui/core/TableRow';

function SplitRow({ split, columns }) {
  return (
    <MuiTableRow>
      {columns.map(col => (
        <MuiTableCell {...col.cellProps} key={`splitRow_${col.name}`}>
          {col.dataGetter(split)}
        </MuiTableCell>
      ))}
    </MuiTableRow>
  );
}

export default SplitRow;
